import { useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { featuredTours } from "../data/site";
import "./page.css";

function TourDetail() {
  const { id } = useParams();
  const tour = featuredTours.find((item) => item.id === id);

  useEffect(() => {
    document.title = tour
      ? `${tour.title} · Mirrorkhan Tours`
      : "Tour not found · Mirrorkhan Tours";
  }, [tour]);

  if (!tour) {
    return (
      <section className="page section-block">
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <p className="eyebrow">Tours</p>
              <h1 className="mb-3">That tour is not on the list.</h1>
              <p className="page-lead mb-4">
                It may have been rested for the season.
              </p>
              <Link className="btn btn-mk-gold" to="/tours">
                Back to tours
              </Link>
            </div>
          </div>
        </div>
      </section>
    );
  }

  return (
    <article className="page section-block">
      <div className="container">
        <div className="row g-4 g-lg-5">
          <div className="col-lg-7">
            <p className="eyebrow">
              <Link to="/tours" className="text-decoration-none">
                Tours
              </Link>
            </p>
            <h1 className="mb-3">{tour.title}</h1>
            <p className="page-lead mb-4">
              {tour.days} days · {tour.place}
            </p>
            <img
              className="img-fluid detail-photo w-100"
              src={tour.image}
              alt={tour.imageAlt}
            />
          </div>
          <div className="col-lg-5">
            <div className="detail-panel">
              <p className="detail-summary mb-4">{tour.summary}</p>
              <Link className="btn btn-mk-gold" to="/contact">
                Ask about this tour
              </Link>
            </div>
          </div>
        </div>
      </div>
    </article>
  );
}

export default TourDetail;
